import React from "react";
import styles from "./AddComment.module.css";
import { Avatar, Button, Box, CircularProgress } from "@mui/material";
import { Mention, MentionsInput } from "react-mentions";
import { useAuthUser } from "react-auth-kit";
import { useSelector, useDispatch } from "react-redux";
import { getCombinedAssignees } from "../../CommonFunctions/CommonFunctions";
import {
  createComment,
  editComment,
} from "../../../pages/app/Nurture/service/nurtureSlice";

function AddComment(props: any) {
  const {
    handleAddComment,
    leadById,
    handleCancelComment,
    employees,
    fromCommentEdit,
    CommentForEditing,
    CreateComment,
    EditComment,
    taskId,
    isGeneralTask,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();

  const { createCommentLoading, updateCommentLoading } = useSelector(
    (state: any) => state.nurture,
  );

  const branchIdForGeneralTask = authUser?.institute?.[0]?.branchId;
  const combinedEmployees = getCombinedAssignees(
    employees,
    isGeneralTask ? branchIdForGeneralTask : leadById?.branchId,
  );

  const activeEmployees = combinedEmployees?.filter((item: any) => {
    if (isGeneralTask) {
      return item.status === "ACTIVE";
    }
    const isActiveAndHasLeadCardAccess =
      item.status === "ACTIVE" && item?.leadCardAccess === true;
    return isActiveAndHasLeadCardAccess;
  });

  const [noteDetails, setNoteDetails] = React.useState({
    description: fromCommentEdit ? CommentForEditing?.description : "",
    enquiryId: "",
    mentionedIds: [],
    createdById: "",
    createdByName: "",
    instituteId: "",
    instituteName: "",
    taskId: "",
  });

  const handleChange = React.useCallback(
    (
      event: any,
      newValue: string,
      newPlainTextValue: string,
      mentions: any,
    ) => {
      const value = newValue || event?.target?.value || "";
      setNoteDetails((prevDetails: any) => ({
        ...prevDetails,
        description: value,
      }));
    },
    [],
  );

  const handleSaveClick = async (event: any) => {
    event.preventDefault();

    if (!noteDetails.description || noteDetails.description.trim() === "") {
      return;
    }

    if (fromCommentEdit) {
      const data: any = {
        id: CommentForEditing?.id,
        description: noteDetails?.description,
        mentionedIds: noteDetails?.mentionedIds || [],
        updatedById: authUser?.institute?.[0]?.id,
        updatedByName: authUser?.firstName + " " + authUser?.lastName,
        taskId: taskId,
      };

      if (isGeneralTask) {
        data.instituteId =
          authUser?.institute?.[0]?.instituteId ||
          authUser?.institute?.[0]?.instituteDetails?.id;
        data.isGeneralTaskComment = true;
      } else if (leadById) {
        data.enquiryId = leadById?.id;
        data.swimlaneState = leadById?.enquirySwimlaneStatus;
        data.instituteId = authUser?.institute?.[0]?.instituteDetails?.id;
        data.instituteName =
          authUser?.institute?.[0]?.instituteDetails?.instituteName;
      }

      dispatch<any>(editComment(data));
    } else {
      if (isGeneralTask) {
        const data = {
          description: noteDetails?.description,
          taskId: taskId,
          createdByName: authUser?.firstName + " " + authUser?.lastName,
          createdById: authUser?.institute?.[0]?.id,
          instituteId:
            authUser?.institute?.[0]?.instituteId ||
            authUser?.institute?.[0]?.instituteDetails?.id,
          mentionedIds: noteDetails?.mentionedIds || [],
          isGeneralTaskComment: true,
        };
        dispatch<any>(createComment(data as any));
      } else {
        const data = {
          ...noteDetails,
          taskId: taskId,
        };
        dispatch<any>(createComment(data));
      }
    }
  };
  function getNameById(id: any) {
    const employee = activeEmployees?.find((e: any) => e.id === id);

    return employee
      ? `${employee.firstName.charAt(0).toUpperCase() +
      employee.firstName.slice(1)
      } ${employee.lastName.charAt(0).toUpperCase() + employee.lastName.slice(1)
      }`
      : "Unknown";
  }

  React.useEffect(() => {
    if (isGeneralTask) {
      const instituteIdValue =
        authUser?.institute?.[0]?.instituteId ||
        authUser?.institute?.[0]?.instituteDetails?.id;

      setNoteDetails((prevDetails: any) => ({
        ...prevDetails,
        createdById: authUser?.institute?.[0]?.id || "",
        createdByName: authUser?.firstName + " " + authUser?.lastName || "",
        instituteId: instituteIdValue || "",
        taskId: taskId || "",
      }));
    } else if (leadById) {
      setNoteDetails((prevDetails: any) => ({
        ...prevDetails,
        enquiryId: leadById.id,
        createdById: authUser?.institute?.[0]?.id || "",
        createdByName: authUser?.firstName + " " + authUser?.lastName || "",
        instituteId: authUser?.institute?.[0]?.instituteDetails?.id || "",
        instituteName:
          authUser?.institute?.[0]?.instituteDetails?.instituteName || "",
        taskId: taskId || "",
      }));
    }
  }, [leadById, isGeneralTask, taskId, authUser]);

  React.useEffect(() => {
    if (fromCommentEdit && CommentForEditing) {
      setNoteDetails((prevDetails: any) => ({
        ...prevDetails,
        description: CommentForEditing?.description || "",
        mentionedIds: CommentForEditing?.mentionedIds || [],
      }));
    }
  }, [CommentForEditing, fromCommentEdit]);

  const modifiedActiveEmployees = activeEmployees?.map((employee: any) => ({
    id: employee.id,
    display: `${employee.firstName} ${employee.lastName}`,
  }));

  return (
    <div>
      <form onSubmit={handleSaveClick}>
        <div
          style={{
            padding: "10px 0px 10px 0",
            position: "relative",
          }}
        >
          <MentionsInput
            value={noteDetails.description}
            onChange={handleChange}
            style={{
              control: {
                backgroundColor: "#fff",
                border: "1px solid #E8E8E8",
                fontSize: "14px",
                color: "#69696B",
                height: "auto",
                minHeight: "79px",
                maxHeight: "150px",
                overflow: "auto",
                borderRadius: "4px",
                padding: "10px 10px",
              },
              highlighter: {
                overflow: "hidden",
              },
              input: {
                margin: 0,
                border: "none",
                top: "10px",
                left: "10px",
                bottom: "10px",
                width: "calc(100% - 22px)",
                height: "auto",
                outline: "none",
              },
              "&singleLine": {
                margin: 0,
              },
              suggestions: {
                width: "222px",
                zIndex: 2,
                overflow: "auto",
                maxHeight: "140px",
                backgroundColor: "#fff",
                border: "1px solid #F0F0F0",
                borderRadius: "6px",
                boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.06)",
                fontSize: "14px",
                position: "absolute",
                padding: "10px",
                color: "#142C44",
                fontWeight: "500",
                lineHeight: "16px",
                top:
                  noteDetails.description?.toString()?.split("\n")?.length <= 1
                    ? 0
                    : noteDetails.description?.toString()?.split("\n")
                      ?.length === 2
                      ? "10%"
                      : noteDetails.description?.toString()?.split("\n")
                        ?.length === 3
                        ? "30%"
                        : noteDetails.description?.toString()?.split("\n")
                          ?.length === 4
                          ? "40%"
                          : noteDetails.description?.toString()?.split("\n")
                            ?.length === 5
                            ? "50%"
                            : noteDetails.description?.toString()?.split("\n")
                              ?.length === 6
                              ? "60%"
                              : "100%",
              },
            }}
          >
            <Mention
              // data={activeEmployees}
              data={modifiedActiveEmployees}
              trigger="@"
              markup="@{{__id__}}"
              // markup="@{{firstName}}"
              style={{
                backgroundColor: "#F5F5F7",
                // color: "#667085",
                padding: "5px",
                marginRight: "5px",
                borderRadius: "20px",
              }}
              displayTransform={(id: any, firstName: any) => {
                return "@" + getNameById(id);
              }}
              onAdd={(id: any) => {
                setNoteDetails((prevDetails: any) => {
                  if (!prevDetails?.mentionedIds?.includes(id)) {
                    return {
                      ...prevDetails,
                      mentionedIds: [...prevDetails?.mentionedIds, id],
                    };
                  }
                  return prevDetails;
                });
              }}
              renderSuggestion={(suggestion: any) => (
                <div
                  style={{
                    paddingBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    textTransform: "capitalize",
                  }}
                >
                  <Avatar
                    sx={{
                      width: "34px",
                      height: "34px",
                      fontSize: "16px",
                      alignItems: "center",
                      textTransform: "capitalize",
                      fontWeight: "500",
                      background: "#F5F5F7",
                      border: "1px solid #EEEEF4",
                      color: "#667085",
                    }}
                  >
                    <Box>{suggestion?.display?.charAt(0)}</Box>
                  </Avatar>
                  {suggestion?.display}
                </div>
              )}
            />
          </MentionsInput>
        </div>

        <div className={styles.activityArea}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div className={styles.cancelSave}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCancelComment}
                sx={{
                  textTransform: "capitalize",
                  color: "#9A9EA6",
                  border: "1px solid #E3E3E3",
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                sx={{
                  marginLeft: 1,
                  textTransform: "capitalize",
                }}
                disabled={
                  (!fromCommentEdit && createCommentLoading) ||
                  (fromCommentEdit && updateCommentLoading) ||
                  !noteDetails?.description?.trim()
                }
              >
                {(!fromCommentEdit && createCommentLoading) ||
                  (fromCommentEdit && updateCommentLoading) ? (
                  <CircularProgress size={20} color={"inherit"} />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddComment;
